module.exports = __webpack_public_path__ + "img/KAREL.aa40c8a9.png";